import { makeStyles } from '@material-ui/core';

export const useCardExpansionPanelStyles = makeStyles(theme => ({
  expansionPanel: {
    boxShadow: 'none',
    padding: 0,
    '&::before': {
      display: 'none'
    },
    backgroundColor: theme.palette.warning.lightBackground
  },
  expansionPanelDetails: {
    display: 'block',
    overflow: 'auto',
    padding: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  expansionPanelSummary: {
    flexDirection: 'row-reverse',
    display: 'flex',
    alignItems: 'center',
    minHeight: 48,
    backgroundColor: 'unset',
    fontSize: theme.typography.body1.fontSize,
    transition: 'min-height 0.2s ease',
    '& .MuiAccordionSummary-content': {
      display: 'flex',
      alignItems: 'center',
      margin: 0,
      padding: 'unset'
    },
    '& .MuiAccordionSummary-expandIcon': {
      marginRight: 0,
      alignSelf: 'center',
      padding: theme.spacing(1)
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  }
}));

export const useNotReferencedProjectRolesStyles = makeStyles(theme => ({
  circularProgress: {
    marginRight: theme.spacing(1)
  },
  expansionPanelSummaryWrapper: {
    width: '100%',
    borderRadius: theme.spacing(0.5)
  },
  noMissingRolesAlert: {
    paddingTop: 'unset',
    paddingBottom: 'unset'
  },
  noMissingRolesTitle: {
    marginTop: 'unset',
    marginBottom: 'unset'
  }
}));

export const useNotReferencedProjectRoleListStyles = makeStyles(theme => ({
  grid: {
    paddingBottom: theme.spacing(1)
  },
  roleItemInteractive: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    transition: 'background-color 0.2s ease',
    position: 'relative',
    minHeight: 40,
    outline: 'none',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    },
    '&:hover $addIcon': {
      opacity: 1
    }
  },
  addIcon: {
    opacity: 0,
    transition: 'opacity 0.2s ease',
    color: theme.palette.warning.dark,
    display: 'flex',
    alignItems: 'center'
  },
  roleText: {
    flexGrow: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.palette.warning.standard
  },
  moreRolesText: {
    flexGrow: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.palette.warning.standard,
    fontStyle: 'italic'
  },
  roleItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    position: 'relative',
    minHeight: 40,
    outline: 'none'
  }
}));

export const useTitleStyles = makeStyles(theme => ({
  title: {
    paddingRight: theme.spacing(1),
    color: theme.palette.warning.standard
  }
}));
